/* <collection-description>: clamps the description to N lines and shows a Read more toggle when it overflows. */
class CollectionDescription extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('.collection-description__text');
    this.toggle = this.querySelector('.collection-description__toggle');
    if (!this.text || !this.toggle) return;

    this.sync = this.sync.bind(this);
    this.onToggle = this.onToggle.bind(this);

    this.toggle.addEventListener('click', this.onToggle);
    window.addEventListener('resize', this.sync);
    /* web fonts can change line counts after first paint, so re-measure once they land */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.sync);

    this.sync();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.sync);
  }

  get expanded() {
    return this.classList.contains('is-expanded');
  }

  get overflowing() {
    return this.text.scrollHeight - this.text.clientHeight > 1;
  }

  sync() {
    /* once expanded the toggle stays visible so it can collapse again */
    if (this.expanded) return;
    this.toggle.hidden = !this.overflowing;
  }

  onToggle() {
    const expanding = !this.expanded;
    this.toggle.setAttribute('aria-expanded', String(expanding));

    /* Reduced motion (or a browser that can't measure): just flip the state. */
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      this.classList.toggle('is-expanded', expanding);
      return;
    }

    /* Tween the text height between collapsed and full; is-animating drops the clamp during the tween. */
    const startHeight = this.text.getBoundingClientRect().height;
    this.classList.toggle('is-expanded', expanding);
    const endHeight = this.text.getBoundingClientRect().height;

    this.classList.add('is-animating');
    this.text.style.height = `${startHeight}px`;
    void this.text.offsetHeight; /* flush the start height before transitioning */
    this.text.style.height = `${endHeight}px`;

    const done = (event) => {
      if (event.target !== this.text || event.propertyName !== 'height') return;
      this.text.removeEventListener('transitionend', done);
      this.classList.remove('is-animating');
      this.text.style.height = '';
    };
    this.text.addEventListener('transitionend', done);
  }
}

customElements.define('collection-description', CollectionDescription);
